<div class="row mt-1" >
  <div class="col-12">
    <div class="progress" style="height: 5px;">
      <div [@statusChange]="{value: statusState}" (@statusChange.done)="onDone($event)" id="progress-busqueda" class="progress-bar bg-success"
        role="progressbar" style="width: 50%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </div>
</div> 